<template>
	<div class="iframe-container">
		<iframe
			:src="source"
			class="iframe-container__iframe"
			scrolling="no"
			frameborder="0"
			ref="frame"
			:sandbox="sandboxVals"
		></iframe>
	</div>
</template>

<script>
export default {
	name: 'IframeContainer',
	props: {
		source: {
			type: String,
			default: ''
		},
		sandbox: {
			type: Array,
			default: () => [
				'allow-forms',
				'allow-modals',
				'allow-popups',
				'allow-scripts',
				'allow-top-navigation',
				'allow-same-origin',
				'allow-top-navigation'
			]
		}
	},
	created() {
		//this.$refs.frame.onload = this.onFrameLoad;
	},
	mounted() {
		document.body.appendChild(this.$el);
		this.$refs.frame.onload = this.onFrameLoad;
		this.$refs.frame.onerror = this.onFrameError;
	},
	computed: {
		sandboxVals() {
			let vals = '';

			if (this.sandbox) {
				vals = this.sandbox.join(' ');
			}

			return vals;
		}
	},
	methods: {
		onFrameError(e) {
			console.log('onFrameError');
			console.log(e);
		},
		onFrameLoad(e) {
			console.log('onFrameLoad');
			console.log(e);
		}
	}
};
</script>

<style lang="scss" scoped>
.iframe-container {
	z-index: $z-level6;
	position: fixed;
	left: 0;
	top: 0;

	&__iframe {
		width: 100vw;
		height: 100vh;
		border: none;
		overflow: hidden;
		margin: 0;
	}
}
</style>
